module.exports = __webpack_public_path__ + "img/ics_f_warning_circle_red.a3fba5d6.svg";